import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import Box from '@tds/core-box';
import Text from '@tds/core-text';
import EN from '../../EN.json';
import FR from '../../FR.json';
import SelectedProducts from './components/selectedProducts';
import { useLocaleContext } from '../context/LocaleContext';
import 'react-datepicker/dist/react-datepicker.css';

const ViewOrderHeader = ({ orderData }) => {
  const locale = useLocaleContext();
  // All lables are fetched from EN.json and FR.json
  const {
    ORDERS: { orderId, businessName, statusText, productsLabel },
    DEFECT_MANAGEMENT: { STATUS }
  } = locale === 'en-US' ? EN : FR;

  const {
    orderId: orderIdvalue,
    legalBusinessNameFM,
    status: statusValue,
    productSelectionFM
  } = orderData;

  return (
    <Fragment>
      <Box pb={12}>
        <Text bold color="#4B286D">
          {orderId}:{' '}
        </Text>
        <Text>{orderIdvalue}</Text>
      </Box>
      <Box pb={12}>
        <Text bold color="#4B286D">
          {businessName}:{' '}
        </Text>
        <Text> {legalBusinessNameFM}</Text>
      </Box>
      <SelectedProducts products={productSelectionFM} label={productsLabel} />
      <Box>
        <Text bold color="#4B286D">
          {STATUS}:{' '}
        </Text>
        <Text>{statusText[statusValue]}</Text>
      </Box>
    </Fragment>
  );
};

ViewOrderHeader.propTypes = {
  orderData: PropTypes.objectOf(PropTypes.object).isRequired
};

export default ViewOrderHeader;
